import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from 'react-router-dom';
// import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { useAuth } from "../../../../../AuthProvider";
import { useParams } from "react-router-dom";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const Unit1ExaminationIndividualResultList = () => {
  
     const location = useLocation(); // ✅ this must come before using `location`
  const { Examtype } = useParams(); 
    const navigate = useNavigate();
    const {oId,board,pId}=useAuth();
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const studentResults = JSON.parse(sessionStorage.getItem("studentResult"));
    const studentProgress = JSON.parse(sessionStorage.getItem("studentProgress"));
    sessionStorage.setItem("studentProgress", JSON.stringify(studentResults));

    const [studentInfo, setStudentInfo] = useState(null);
  const [open, setOpen] = useState(false);

  const handleSelectType = (path) => {
    sessionStorage.setItem("studentProgress", JSON.stringify(studentResults));
    navigate(path);
    setOpen(false);
  };

  const fetchData = async () => {
  if (!oId || !pId || !studentProgress?.studentId || !studentProgress?.type) {
    console.warn("Missing oId, pId, or studentProgress");
    return;
  }
setLoading(true);
  try {
    const url = `${baseUrl}/api/subjectMarks/getStudentReportCard/${studentProgress.studentId}/${oId}/${pId}?examType=${studentProgress.type}`;
    const response = await fetch(url);
    if (!response.ok) {
      console.error("API Error:", response.status, response.statusText);
      return;
    }
    const data = await response.json();
    if (data) {
      setFilteredData(data.subjects || []); // ✅ Only set subjects array
      setStudentInfo(data); // if you want to use studentId, class, section etc.
    }
  } catch (error) {
    console.error("Error fetching student data:", error);
  } finally {
    setLoading(false); // ✅ stop loading always
  }
};
  useEffect(() => {
    if (oId && pId && studentProgress?.studentId && studentProgress?.type) {
      fetchData();
    }
  }, [oId, pId, studentProgress?.studentId, studentProgress?.type]);
const uniqueHues = [0, 30, 60, 120, 200, 210, 270, 300]; 
// Using Sky Blue (200° HSL) instead of Cyan (180° HSL)

const pieData = filteredData.map((row, index) => ({
  name: row.subject,
  value: row.marks,
  color: `hsl(${uniqueHues[index % uniqueHues.length]}, 80%, 50%)` // Moderate dark colors
}));

const [activeIndex, setActiveIndex] = useState(null);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const onPieLeave = () => {
    setActiveIndex(null);
  };
const [progressTheme, setProgressTheme] = useState("ProgressCard");

   const handleSelectProgress = (type) => {
    navigate(`/${type}`);
  };

useEffect(() => {
  const fetchSavedProgressTheme = async () => {
    try {
      const res = await fetch(`${baseUrl}/api/principal/getTheme/${pId}`);
      const data = await res.json();

      if (data.reportCardTheme) {
        setProgressTheme(data.reportCardTheme);
      }
    } catch (error) {
      console.error("Error fetching saved Progress theme:", error);
    }
  };

  fetchSavedProgressTheme();
}, [pId, baseUrl]);

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>

        <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }} >
  <ArrowBackIcon />
</IconButton>
<Typography
  variant="h5"
  sx={{
    fontWeight: "bold",
    mb: 3,
    textAlign: "left", // Align the text to the left
    display: "inline-block", // Make the text and icon inline
     // Add some space between the icon and the text
  }}
>
{studentResults?.firstName || ""} {studentResults?.lastName} Results
</Typography>

<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
<Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1.5 }}>
  {/* First Row: Student ID, Name, Course (if INTERMEDIATE) */}
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
    <Typography variant="body1" sx={{ minWidth: 180 }}>
      <strong>Student Id:</strong> {studentResults?.studentId || "-"}
    </Typography>
    <Typography variant="body1" sx={{ minWidth: 220 }}>
      <strong>Student Name:</strong> {studentResults?.firstName || ""} {studentResults?.lastName || ""}
    </Typography>
    {board === "INTERMEDIATE" && (
      <Typography variant="body1" sx={{ minWidth: 150 }}>
        <strong>Course:</strong> {studentResults?.course || "-"}
      </Typography>
    )}
  </Box>

  {/* Second Row: Class/Year and Section */}
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>{board === "INTERMEDIATE" ? "Year:" : "Class:"}</strong> {studentResults?.romanNumberClass || "-"}
    </Typography>
    <Typography variant="body1" sx={{ minWidth: 150 }}>
      <strong>Section:</strong> {studentResults?.sections || "-"}
    </Typography>
  </Box>
</Box>
  {/* Download Button on the right */}
 <Button
  type="button"
  onClick={() =>{
    sessionStorage.setItem("studentProgress", JSON.stringify(studentResults));
     handleSelectProgress(progressTheme || "ProgressCard")}}

  sx={{
    backgroundColor: "#3C3972",
    fontWeight: "bold",
    color: "white",
    "&:hover": { backgroundColor: "#3C3972" },
  }}
>
  View Progress Card
</Button>
</Box>
          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

<div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>

<div style={{ 
    width: "69%", // Adjusted width to fit alongside the table
    backgroundColor: "#fff", 
    borderRadius: "8px", 
    padding: "5px", 
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)", 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center",
    minHeight:"350px"
  }}>
{/* table data */}
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ border: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>S.No</TableCell>
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", whiteSpace: "nowrap",fontWeight:'bold', backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontSize:"13px"}}>Date</TableCell> */}
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Subject</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:"13px" }}>Marks</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:"13px" }}>Grade</TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                   <TableCell
                                                     colSpan={5}
                                                     style={{ textAlign: "center", padding: "20px" }}
                                                   >
                                                     <Box
                                                       display="flex"
                                                       flexDirection="column"
                                                       alignItems="center"
                                                     >
                                                       <CircularProgress />
                                                       <Typography variant="body2" sx={{ mt: 1 }}>
                                                         Loading Data...
                                                       </Typography>
                                                     </Box>
                                                   </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
              <TableBody>
  {filteredData.map((row, index) => (
    <TableRow
      key={index}
      style={{
        backgroundColor: "white",
        transition: "background-color 0.3s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f1f1f1")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
    >
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {index + 1}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.subject}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.marks}/{row.subjectMarks}   {/* ✅ updated key */}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.grade}
      </TableCell>
    </TableRow>
  ))}
</TableBody>

              )}
            </Table>
          </TableContainer>
          </div>
  {/* Pie Chart Section */}
  <div
      style={{
        width: "30%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "300px",
      }}
    >
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "10px",
          color: "#333",
        }}
      >
        Subject Wise Performance
      </Typography>

      <PieChart width={250} height={300}>
      {pieData.length > 0 && pieData.some((entry) => entry.value > 0) ? (
        <Pie
          data={pieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={80}
          innerRadius={50}
          onMouseEnter={onPieEnter}
          onMouseLeave={onPieLeave}
          label={({ value, percent }) => `${value}`}
        >
          {pieData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.color}
              style={{ cursor: "pointer", transition: "all 0.3s ease-in-out" }}
              stroke={activeIndex === index ? "#000" : "none"}
              strokeWidth={activeIndex === index ? 2 : 1}
            />
          ))}
        </Pie>
        ) : (
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            style={{ fontSize: "14px", fontWeight: "bold", fill: "#777" }}
          >
            No Data Available
          </text>
        )}
        <Tooltip formatter={(value, name, props) => [`${value}%`, props.payload.name]} />
        <Legend />
      </PieChart>
    </div>
</div>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Unit1ExaminationIndividualResultList;